const ERROR_MESSAGES: Record<string, string> = {
  DB_CONNECTION_ERROR: 'Unable to connect. Please try again.',
  INVALID_PARAM: 'Please check your input.',
  NOT_FOUND: 'The requested item was not found.',
  FORBIDDEN: 'You do not have permission for this action.',
  CONFLICT: 'This user is already assigned to the task.',
  COLUMN_NOT_EMPTY: 'Move or delete all tasks before removing this column.',
  SERVER_ERROR: 'Something went wrong. Please try again.',
};

export const getTodoErrorMessage = (code: string): string =>
  ERROR_MESSAGES[code] || 'An unexpected error occurred.';
